import React, { useEffect, useMemo, useState } from "react";
import api from "@/lib/api";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

export default function Schedule() {
  const [events, setEvents] = useState([]);
  const [sport, setSport] = useState("all");
  const [type, setType] = useState("all");

  useEffect(() => { api.get("/events").then(r => setEvents(r.data)).catch(() => {}); }, []);

  const filtered = useMemo(() => events.filter(e =>
    (sport === "all" || e.sport === sport) && (type === "all" || e.event_type === type)
  ), [events, sport, type]);

  return (
    <div data-testid="schedule-page">
      <section className="bg-scu-obsidian text-white">
        <div className="mx-auto max-w-[1400px] px-4 lg:px-8 py-20">
          <div className="text-xs uppercase tracking-[0.35em] text-scu-electric">Season 2027</div>
          <h1 className="mt-3 font-bebas text-6xl md:text-8xl tracking-wider">Schedule</h1>
          <p className="mt-2 text-white/70">Practices, games and events across all divisions.</p>
        </div>
        <div className="stripe-divider" />
      </section>

      <section className="mx-auto max-w-[1400px] px-4 lg:px-8 py-12">
        <div className="flex flex-wrap gap-4 items-center">
          <div className="min-w-[180px]">
            <div className="text-xs uppercase tracking-widest text-scu-smoke font-bold mb-1">Sport</div>
            <Select value={sport} onValueChange={setSport}>
              <SelectTrigger data-testid="sch-sport"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="all">All</SelectItem>
                <SelectItem value="football">Football</SelectItem>
                <SelectItem value="cheer">Cheer</SelectItem>
                <SelectItem value="both">Both</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="min-w-[180px]">
            <div className="text-xs uppercase tracking-widest text-scu-smoke font-bold mb-1">Type</div>
            <Select value={type} onValueChange={setType}>
              <SelectTrigger data-testid="sch-type"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="all">All</SelectItem>
                <SelectItem value="practice">Practice</SelectItem>
                <SelectItem value="game">Game</SelectItem>
                <SelectItem value="event">Event</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>

        <div className="mt-8 divide-y divide-scu-smoke/15 border border-scu-smoke/15 rounded-md bg-white">
          {filtered.length === 0 && <div className="p-8 text-scu-smoke text-sm">No events match the current filters.</div>}
          {filtered.map((e) => (
            <div key={e.id} className="p-6 flex flex-col md:flex-row md:items-center gap-4 hover:bg-scu-off transition-colors" data-testid={`schedule-event-${e.id}`}>
              <div className="flex flex-col items-center justify-center bg-scu-obsidian text-white w-20 h-20 rounded-md flex-shrink-0">
                <div className="text-[10px] uppercase tracking-widest text-scu-electric">{new Date(e.date).toLocaleString('default', { month: 'short' })}</div>
                <div className="font-bebas text-3xl">{new Date(e.date).getDate()}</div>
              </div>
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-[10px] uppercase tracking-widest font-bold text-scu-purple bg-scu-purple/10 px-2 py-1 rounded">{e.event_type}</span>
                  <span className="text-[10px] uppercase tracking-widest font-bold text-scu-smoke">{e.sport}{e.division ? ` · ${e.division}` : ''}</span>
                </div>
                <div className="font-bold text-lg text-scu-obsidian">{e.title}</div>
                <div className="text-sm text-scu-smoke">{e.time} · {e.location}{e.opponent ? ` · vs ${e.opponent}` : ''}</div>
                {e.notes && <div className="text-sm text-scu-smoke/80 mt-1 italic">{e.notes}</div>}
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
